// extracted by mini-css-extract-plugin
export default {"alignTabButton":"DistributeActionButton_alignTabButton__oOz4L"};